// extracted by mini-css-extract-plugin
export default {"emptyFieldValue":"index-module__emptyFieldValue--_xE7x","linkedPullRequestContainer":"index-module__linkedPullRequestContainer--PC7E2"};